<template>
	<el-dialog :visible.sync="isshow" :title="dialogtitle" width="550px" 
	:append-to-body="true" :close-on-click-modal="false">
		<div class="downpic">
			<el-form ref="form" label-width="100px" size="mini">
				<el-form-item :label="downpic_lang.filename">
					<el-select v-model="namerule" style="width:100%">
						<el-option v-for="(item, index) in typelist" :key="index" :label="item.name" :value="item.name"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer" style="padding-top:0px">
				<div style="text-align: center;">
					<el-button type="success" :disabled="btndisabled" size="mini" @click="godownpic">{{suretext}}</el-button>
					<el-button @click="isshow = false" size="mini">{{canceltext}}</el-button>
				</div>
			</span>
		</div>
	</el-dialog>
</template>
<script>
import Utils from '../../lib/util.js';	
export default {
	data() {
		return {
			btndisabled:false,
			typelist:[],
			filenamerule:localStorage.getItem('downpicrule'),
			pageparam: {},
			searchinfo: {},
			batch: '',
			divclass: 'downpic',
			sys:'',
			isshow:false,
			downpic_lang:{},
			dialogtitle:'',
			suretext:'',
			canceltext:'',
			item:{},
			namerule:''
		}
	},
	methods: {
		init(param){
			debugger
			//this.isshow=true;
			if(param.searchinfo!=undefined)
				this.searchinfo = param.searchinfo;
			if(param.item!=undefined)
				this.item=param.item;
			var that=this;
			this.$public.GetLanguageByMode('downpic',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.isshow=true;
					that.suretext=that.$lang.label.public.sure;
					that.canceltext=that.$lang.label.public.cancel;
					that.downpic_lang=that.$lang.label.downpic;
					that.dialogtitle=that.downpic_lang.dialogtitle;
					that.typelist= [{ name: that.downpic_lang.cno,value:'cno' }];
					if(that.typelist.length>0)
						that.namerule=that.typelist[0].name;
						
				}
			});		
		},
		godownpic(){
			debugger
			var that=this;
			var list=this.typelist.filter(function(e){ return e.name==that.namerule});
			if(list.length>0)
			{
				this.filenamerule=list[0].value;
				localStorage.setItem("downpicrule",this.filenamerule);
			}	
			this.$public.downcargopic(this,this.searchinfo);
		}
	}
}	
</script>
<style>
</style>